import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './MediaFeaturesSection.css';
import YouTubePlayer from '../Video/YouTubePlayer';

const MediaFeaturesSection = () => {
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  const videos = [
    {
      id: 'cspan',
      title: 'As Seen on C-Span',
      thumbnail: imgCDNURL + 'MediaFeaturesSection/cspan-thunbnail.webp',
      videoId: ''
    },
    {
      id: 'fox',
      title: 'As Seen on Fox Business',
      thumbnail: imgCDNURL + 'MediaFeaturesSection/fox-thumbnail.webp',
      videoId: 'aEt8a0pdwTw'
    }
  ];

  return (
    <div className="media-section-wrapper">
      <Container>
        <Row className="justify-content-center">
          {videos.map((video) => (
            <Col md={6} className="media-card-column" key={video.id}>
              <div className="media-card">
                <div className="media-header">{video.title}</div>
                <div className="media-video-container">
                  {/* Thumbnail */}
                  {(playingVideoId !== video.id || video.id === 'cspan') && (
                    <div className="media-thumbnail-wrapper">
                      {video.id === 'cspan' ? (
                        <a
                          href="https://www.c-span.org/program/public-affairs-event/former-rep-patrick-mchenry-on-ai-and-digital-asset-regulation/662174"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={video.thumbnail}
                            alt={video.title}
                            className="media-thumbnail"
                          />
                          <button className="media-play-button">▶</button>
                        </a>
                      ) : (
                        <>
                          <img
                            src={video.thumbnail}
                            alt={video.title}
                            className="media-thumbnail"
                            onClick={() => setPlayingVideoId(video.id)}
                          />
                          <button
                            className="media-play-button"
                            onClick={() => setPlayingVideoId(video.id)}
                          >
                            ▶
                          </button>
                        </>
                      )}
                    </div>
                  )}

                  {/* YouTube Player */}
                  {video.id !== 'cspan' && playingVideoId === video.id && (
                    <>
                      <div className="media-iframe-wrapper">
                        <YouTubePlayer videoId={video.videoId} />
                      </div>
                      <button
                        className="media-close-button"
                        onClick={() => setPlayingVideoId(null)}
                        aria-label="Close Video"
                      >
                        ×
                      </button>
                    </>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default MediaFeaturesSection;
